var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "成为合伙人",
        width: "450px",
        visible: _vm.dialogVisible,
        "append-to-body": "",
        fullscreen: _vm.device === "mobile",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.dialogClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "partnerForm",
          attrs: {
            model: _vm.detail,
            rules: _vm.partnerRules,
            "label-width": "100px",
          },
        },
        [
          _c("el-form-item", { attrs: { label: "用户昵称" } }, [
            _c("div", { staticClass: "el-input el-input--small" }, [
              _c("span", { staticClass: "el-input__inner" }, [
                _vm._v(_vm._s(_vm.detail.nickName)),
              ]),
            ]),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "合伙人身份", prop: "partnership" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择合伙人身份" },
                  model: {
                    value: _vm.detail.partnership,
                    callback: function ($$v) {
                      _vm.$set(_vm.detail, "partnership", $$v)
                    },
                    expression: "detail.partnership",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "合作商", value: 3 } }),
                  _c("el-option", { attrs: { label: "联盟企业", value: 4 } }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.dialogClose } }, [
            _vm._v("取　消"),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("确　定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }